module.exports = __webpack_public_path__ + "img/20250917_2.8c2867b8.png";